import { render, staticRenderFns } from "./bookingsPage.vue?vue&type=template&id=1ec95820&scoped=true&"
import script from "./bookingsPage.vue?vue&type=script&lang=ts&"
export * from "./bookingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./bookingsPage.vue?vue&type=style&index=0&id=1ec95820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec95820",
  null
  
)

export default component.exports